import CommonEntry from 'components_v2/_entryPoints/grouped/CommonEntry'
import React from 'react'

const Entry = (props) => <CommonEntry entryPage='classPage' {...props} />

export default Entry
